import { Injectable } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { AnalyticsService } from './analytics.service';
import { TokenizationService } from './tokenization.service';
import { Globals } from '../globals';
import { Observable, Subscription, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenizationBootstrapService {

  constructor(
    private analytics: AnalyticsService,
    private tokenization: TokenizationService,
  ) { }

  subscribeToQueryParams(
    route: ActivatedRoute,
    unsubscriber$: Observable<void>
  ): Subscription {
    return route.queryParamMap
      .pipe(takeUntil(unsubscriber$))
      .subscribe(params => this.applyQueryParams(params));
  }

  applyQueryParams(params: ParamMap): void {
    /* id */
    let id = params.get('id') || '';
    id = id.split('/')[0];
    this.tokenization.medioPagoId = id;

    /* contactId */
    const contactId = params.get('contactId') || '';
    this.analytics.setContactId(contactId);

    /* status */
    const status = params.get('status') || '';

    if (status !== '') {
      window.parent.postMessage({ id, status }, Globals.originUrl);
    }
  }
}
